import apiRequest from '../util/apiRequest';
import {
  SET_ALL_MESSAGE_TEMPLATES,
  SET_ALL_SEGMENTS,
  SET_MESSAGE_CONTENT,
  SET_MESSAGE_TEMPLATE_DETAIL,
  UPDATE_MESSAGE_CONTENT,
  UPDATE_MESSAGE_CONTENT_ID,
  CREATE_SEGMENT_FROM_S3,
  CREATE_SEGMENT_FROM_FILE as CREATE_SEGMENT_RESPONSE,
  CREATE_SEGMENT_FROM_RULES,
  GET_ALL_TEMPLATES_TRACKER,
  UPDATE_TEMPLATE_SUBJECT,
  SET_SELECTED_TEMPLATE,
  UPDATE_FORM_TYPE,
  UPDATE_TEMPLATE_NAME,
  RESET_TEMPLATE_FORM,
  UPDATE_TEMPLATE_CREATE_STATUS,
  UPDATE_TEMPLATE_EDIT_STATUS,
  UPDATE_TEMPLATE_DELETE_STATUS,
} from './nudgeActionTypes';
import {
  CREATE_MESSAGE_TEMPLATE_URL,
  CREATE_NEW_SEGMENT_USING_S3_URL,
  CREATE_NEW_SEGMENT_WITH_RULES,
  GET_ALL_MESSAGE_TEMPLATES_URL,
  GET_ALL_SEGMENTS_URL,
  GET_MESSAGE_TEMPLATE_DETAILS_URL,
  CREATE_SEGMENT_FROM_FILE_URL,
  UPDATE_MESSAGE_TEMPLATE,
  DELETE_MESSAGE_TEMPLATE,
} from '../constants/urlConstants';
import { ResponseStatus } from '../enums/responseStatus';
import { GET_ALL_SEGMENT_TRACKER } from './createSegmentActionTypes';
import { API_ERROR } from '../constants/editorConfig';
import { SHOW_NOTIFICATON } from './notificationActionsType';
import { DEFAULT_NOTIFICATION_TIMEOUT_MS, MessageType } from '../constants/createSegment';
import {
  TEMPLATE_CREATE_ERROR,
  TEMPLATE_CREATE_SUCCESS,
  TEMPLATE_DELETE_ERROR,
  TEMPLATE_DELETE_SUCCESS,
  TEMPLATE_UPDATE_ERROR,
  TEMPLATE_UPDATE_SUCCESS,
} from '../constants/messages';
import { CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL } from "./createScheduleActionTypes";

/**
 * To fetch all the segments for given UserGroupName.
 *
 * @param {*} userGroupName
 * @param {*} sessionToken
 * @returns
 */
export const getAllSegments = (userGroupName, sessionToken) => dispatch => {
  let status = ResponseStatus.RUNNING;
  let data = [];
  dispatch({
    type: GET_ALL_SEGMENT_TRACKER,
    payload: { data, status },
  });
  return apiRequest(
    GET_ALL_SEGMENTS_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        userGroupName: userGroupName,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error('400');
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      data = res?.segmentList;
      dispatch({
        type: SET_ALL_SEGMENTS,
        payload: res?.segmentList,
      });
      dispatch({
        type: GET_ALL_SEGMENT_TRACKER,
        payload: { data: res?.segmentList ?? [], status },
      });
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: GET_ALL_SEGMENT_TRACKER,
        payload: data,
      });
    });
};

// Added a placeholder for create Segments with rules API request
// TODO: Once the API is ready it needs to be configured here
export const createSegmentWithRules = (newSegment, sessionToken) => dispatch => {
  let status = '';
  let data = {};
  dispatch({
    type: CREATE_SEGMENT_RESPONSE,
    payload: {
      data,
      status,
    },
  });
  return apiRequest(
    CREATE_NEW_SEGMENT_WITH_RULES,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(newSegment),
    },
    sessionToken,
  )
    .then(res => {
      if (res?.status >= 400) {
        status = ResponseStatus.ERROR;
      } else {
        status = ResponseStatus.SUCCESS;
      }
      return res.json();
    })
    .then(res => {
      data = res;
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL, payload: data });
      dispatch({
        type: CREATE_SEGMENT_RESPONSE,
        payload: {
          data,
          status,
        },
      });
    });
};

export const createSegmentFromS3 = (newSegment, sessionToken) => dispatch => {
  let status = '';
  let data = {};
  dispatch({
    type: CREATE_SEGMENT_RESPONSE,
    payload: {
      data,
      status,
    },
  });
  return apiRequest(
    CREATE_NEW_SEGMENT_USING_S3_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(newSegment),
    },
    sessionToken,
  )
    .then(res => {
      if (res?.status >= 400) {
        status = ResponseStatus.ERROR;
      } else {
        status = ResponseStatus.SUCCESS;
      }
      return res.json();
    })
    .then(res => {
      data = res;
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL, payload: data });
      dispatch({
        type: CREATE_SEGMENT_RESPONSE,
        payload: {
          data,
          status,
        },
      });
    });
};

export const createSegmentFromFile = (segmentDetail, sessionToken) => dispatch => {
  let status = '';
  let data = {};
  dispatch({
    type: CREATE_SEGMENT_RESPONSE,
    payload: {
      data,
      status,
    },
  });
  return apiRequest(
    CREATE_SEGMENT_FROM_FILE_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(segmentDetail),
    },
    sessionToken,
  )
    .then(res => {
      if (res?.status >= 400) {
        status = ResponseStatus.ERROR;
      } else {
        status = ResponseStatus.SUCCESS;
      }
      return res.json();
    })
    .then(res => {
      data = res;
    })
    .catch(() => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({ type: CAMPAIGN_FORM_UPDATE_SEGMENT_DETAIL, payload: data });
      dispatch({
        type: CREATE_SEGMENT_RESPONSE,
        payload: {
          data,
          status,
        },
      });
    });
};
/**
 * To get all the available message templates for given UserGroupName
 *
 * @param {*} userGroupName
 * @param {*} sessionToken
 * @returns
 */
export const getAllMessageTemplates = (userGroupName, sessionToken) => dispatch => {
  let status = ResponseStatus.PENDING;
  dispatch({
    type: GET_ALL_TEMPLATES_TRACKER,
    payload: {
      status,
      data: [],
    },
  });
  return apiRequest(
    GET_ALL_MESSAGE_TEMPLATES_URL,
    {
      method: 'POST',
      body: JSON.stringify({
        userGroupName,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        status = ResponseStatus.ERROR;
        throw Error('400');
      }
      return res.json();
    })
    .then(res => {
      status = ResponseStatus.SUCCESS;
      dispatch({
        type: SET_ALL_MESSAGE_TEMPLATES,
        payload: res?.messageTemplateList,
      });
      dispatch({
        type: GET_ALL_TEMPLATES_TRACKER,
        payload: {
          status,
          data: res?.messageTemplateList,
        },
      });
    })
    .catch(ex => {
      status = ResponseStatus.ERROR;
    })
    .finally(() => {
      dispatch({
        type: GET_ALL_TEMPLATES_TRACKER,
        payload: {
          status,
          data: [],
        },
      });
    });
};

/**
 * To fetch the template details of given MessageTemplateName.
 *
 * @param {*} messageTemplateName
 * @param {*} sessionToken
 * @returns
 */
export const getMessageTemplateDetails = (messageTemplateName, sessionToken) => dispatch => {
  return apiRequest(
    GET_MESSAGE_TEMPLATE_DETAILS_URL,
    {
      method: 'POST',
      body: JSON.stringify({
        messageTemplateName,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        throw Error('400');
      }
      return res.json();
    })
    .then(res => {
      dispatch({
        type: SET_MESSAGE_TEMPLATE_DETAIL,
        payload: res,
      });
    })
    .catch(ex => console.log(ex));
};

/**
 * This action saves the message template using the create content container
 *
 * @param {*} userName
 * @param {*} userGroupName
 * @param {*} messageTemplate
 * @param {*} sessionToken
 * @returns
 */
export const saveMessageContent = (
  userName,
  userGroupName,
  messageTemplate,
  sessionToken,
) => dispatch => {
  return apiRequest(
    CREATE_MESSAGE_TEMPLATE_URL,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        userName,
        userGroupName,
        messageTemplate,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        throw Error('400');
      }
      return res.json();
    })
    .then(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_CREATE_SUCCESS,
        },
      });
      dispatch(updateTemplateCreateStatus(ResponseStatus.SUCCESS));
      dispatch(resetTemplateForm());
    })
    .catch(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_CREATE_ERROR,
        },
      });
      dispatch(updateTemplateCreateStatus(ResponseStatus.ERROR));
    });
};

export const updateMessageTemplate = (userName, messageTemplate, sessionToken) => dispatch => {
  return apiRequest(
    UPDATE_MESSAGE_TEMPLATE,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        userName,
        messageTemplate,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        throw Error();
      }
      return res.json();
    })
    .then(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_UPDATE_SUCCESS,
        },
      });
      dispatch(updateTemplateEditStatus(ResponseStatus.SUCCESS));
      dispatch(resetTemplateForm());
    })
    .catch(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_UPDATE_ERROR,
        },
      });
      dispatch(updateTemplateEditStatus(ResponseStatus.ERROR));
    });
};

export const deleteMessageTemplate = (messageTemplateName, sessionToken) => dispatch => {
  return apiRequest(
    DELETE_MESSAGE_TEMPLATE,
    {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        messageTemplateName,
      }),
    },
    sessionToken,
  )
    .then(res => {
      if (!res.ok) {
        throw Error();
      }
      return res.json();
    })
    .then(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.SUCCESS,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_DELETE_SUCCESS,
        },
      });
      dispatch(updateTemplateDeleteStatus(ResponseStatus.SUCCESS));
      dispatch(resetTemplateForm());
    })
    .catch(() => {
      dispatch({
        type: SHOW_NOTIFICATON,
        payload: {
          type: MessageType.ERROR,
          timeout: DEFAULT_NOTIFICATION_TIMEOUT_MS,
          message: TEMPLATE_DELETE_ERROR,
        },
      });
      dispatch(updateTemplateDeleteStatus(ResponseStatus.ERROR));
    });
};

export const updateMessageContent = data => dispatch => {
  dispatch({
    type: UPDATE_MESSAGE_CONTENT,
    payload: data,
  });
};

export const updateContentId = data => dispatch => {
  dispatch({
    type: UPDATE_MESSAGE_CONTENT_ID,
    payload: data,
  });
};

export const setSelectedTemplate = data => dispatch => {
  dispatch({
    type: SET_SELECTED_TEMPLATE,
    payload: data,
  });
};

export const updateTemplateSubject = data => dispatch => {
  dispatch({
    type: UPDATE_TEMPLATE_SUBJECT,
    payload: data,
  });
};

export const updateTemplateName = data => dispatch => {
  dispatch({
    type: UPDATE_TEMPLATE_NAME,
    payload: data,
  });
};

export const updateTemplateFormType = data => dispatch => {
  dispatch({
    type: UPDATE_FORM_TYPE,
    payload: data,
  });
};

export const resetTemplateForm = () => dispatch => {
  dispatch({
    type: RESET_TEMPLATE_FORM,
    payload: null,
  });
};

export const updateTemplateCreateStatus = status => dispatch => {
  dispatch({
    type: UPDATE_TEMPLATE_CREATE_STATUS,
    payload: status,
  });
};

export const updateTemplateEditStatus = status => dispatch => {
  dispatch({
    type: UPDATE_TEMPLATE_EDIT_STATUS,
    payload: status,
  });
};

export const updateTemplateDeleteStatus = status => dispatch => {
  dispatch({
    type: UPDATE_TEMPLATE_DELETE_STATUS,
    payload: status,
  });
};
